import React from 'react'
import Img from '../img/about-sba-tax.webp'
// import akMerchant from '../img/ak-merchant.png'
// import akMerchant from '../img/ak-merchant-white-updated.webp'
import akMerchant from '../img/ak-merchant-green-updated.webp'
import BharathSir from '../img/bharat-sir.jpeg'


export default function AboutH() {
  return (

    <>  
        
        <section className='py-5' id='aboutHome'>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-12">
                        <h1 data-aos="fade-up" data-aos-delay="200" className='h2 fw-bold text-center primary-text'>SBA Tax Consultant in USA</h1>
                    </div>
                    <div className="col-md-12 text-center py-3 mb-3">
                        <button data-aos="fade-up" data-aos-delay="200" className='btn btn-danger rounded-pill px-4 mb-2'>Who we are?</button> &nbsp;&nbsp;&nbsp;
                        <button data-aos="fade-up" data-aos-delay="200" className='btn btn-danger rounded-pill px-4 mb-2'>What we do?</button> &nbsp;&nbsp;&nbsp;
                        
                        <button data-aos="fade-up" data-aos-delay="200" className='btn btn-danger rounded-pill px-5 mb-2'>Service</button> &nbsp;&nbsp;&nbsp;
                        <button data-aos="fade-up" data-aos-delay="200" className='btn btn-danger rounded-pill px-4 mb-2'>Financial Planning</button> &nbsp;&nbsp;&nbsp;
                    </div>
                    
                    <div className="col-md-7" data-aos="fade-up" data-aos-offset="300" >
                       
                        <p>Welcome to SBA Tax Consultants, your go-to source for all of your tax and accounting needs. Our company was founded by team of <span className='primary-text fw-bold'>Professionals and a Certified Public Accountants (CPA)</span> who have extensive experience in the financial industry. With our knowledgeable staff and commitment to excellence, we strive to provide top-notch Tax Advisory Services to individuals and businesses alike.</p>
                        
                        <p>At SBA Tax Consultants, we understand the complexities of tax law and the importance of financial planning for both individuals and businesses. Our team consists of <span className=''>highly skilled CPAs and other Professionals</span>, who have a deep understanding of the ever-changing tax regulations in the United States. We are dedicated to helping our clients navigate the intricate world of taxes, ensuring that they receive all applicable deductions and credits while remaining compliant with all laws.</p>
                        
                        <p>We offer a wide range of services to meet all of your tax and accounting needs. Our team is well-versed in handling personal and corporate taxes, as well as providing assistance with payroll and other financial tasks necessary for running a successful business. We work closely with our clients to create personalized solutions tailored to their specific needs.</p>
                        <p>Expert Tax Consultants for Personalized Financial Solutions at SBA Tax Consultants, we pride ourselves on being your trusted partner in all tax and accounting matters.</p>
                        <a href="./about-us"><button className="btn btn-danger">Know more about us.</button></a>
                    </div>
                    <div className="col-md-5" data-aos="fade-up" data-aos-offset="300">
                        <img src={Img} alt="About SBA Tax Consultant" className="img-fluid" />
                    </div>
                    
                </div>
            </div>
        </section>
                        {/*-------------- Founders are commented on 11-03-2025     -------------- */}
                        
        <section>
            <div className="container">
                <div className="row align-items-center justify-content-center" id='FounderSec'>
                
                <div className="col-md-12">
                    <h3 className='fw-bold primary-text text-center mb-5'>Founders</h3>
                    {/* <div className="row align-items-center border-bottom pb-3">
                        <div className="col-md-3" data-aos="fade-up" data-aos-offset="300">
                            <img src={akMerchant} alt="img" className='img-fluid shadow border rounded' />
                        </div>
                        <div className="col-md-9" data-aos="fade-up" data-aos-offset="300">
                            
                            <h4 className='pt-3 fw-bold'>Akshay Merchant</h4>
                            <h6 className='primary-text'>Chief Operations Officer</h6>
                            <h6 className='mt-4'>Qualification: </h6>
                            <h6 className='secondary-text'> CPA, CMA, EA, CSCA, CA (India), ACCA (UK), FIII, M. Com & BMS</h6>
                        
                            <p>A successful individual, adept in analytical and creative thinking, navigates challenges with strategic precision. Their motivation and self-awareness serve as catalysts, driving not only personal growth but inspiring teams to excel.</p>
                            <a href="./about-us" className='btn btn-danger rounded-pill'>Know More</a>
                            <p></p>
                            
                        </div>                        
                    </div> */}

                    <div className="row align-items-center border-bottom pb-3 mt-5">
                        
                        <div className="col-md-9" data-aos="fade-up" data-aos-offset="350">
                          
                            <h4 className='fw-bold pt-3'>Dr. Bharath Kumar Kakkireni</h4>
                            <h6 className='primary-text'>Chief Technical Advisor</h6>
                            <h6 className='mt-4'>Qualification: </h6>
                            <h6 className='secondary-text'> B.Pharm, MSM, MS, USA</h6>
                            
                            <p>A sharp focus businessman Dr. K.Bharath Kumar is the Chairman and CEO of KBK Group of companies. From Hospital to IT, his passion and effort brings him to lead the success. With the right attitude, you can achieve success in any field.</p>
                            <a href="./about-us" className='btn btn-danger rounded-pill'>Know More</a>
                            <p></p>
                            
                        </div>
                        <div className="col-md-3" data-aos="fade-up" data-aos-offset="350">
                            <img src={BharathSir} alt="img" className='img-fluid rounded' />
                        </div>
                        
                        
                    </div>
                </div>

                </div>
            </div>
        </section>
    </>
  )
}
